/**
*@Time : 2020/9/2 下午1:28
*@Author : Hejie Shao
*/
<template>
  <div class="home-container">
    <img src='@/assets/icon_logo_official.png' class="logo-icon" key="company-logo">
    <prodWarpper>
      <!-- <prod-item link="https://linglu.ihapi.com" background="#02120E" link-color="#02120E">
        <img src='@/assets/img_logo_linglu.png'  key="linglu-logo" slot="prologo">
        <div slot="protitle">
          <div key="drawfee-text" style="color: white; font-size: 40px;">你的AI摄影师</div>
        </div>
        <div slot="protext" style="color:#A9B5B7">灵鹿AI使用人工智能技术帮助用户生成高质量的摄影照片，用户可以在不需要专业摄影师或摄影棚的情况下，轻松地生成自己的各种艺术照以及电影级别的大片。</div>
        <img slot="proimage" src='@/assets/img_main_linglu.png' class="prod-img" key="linglu-img">
        <div slot="linkdetail" style="border-radius: 20px; background-image: linear-gradient(to right, #4CBECC, #3AC9AC, #B2F291)">
          <span style="color: black">了解详情</span>
          <img src='@/assets/icon_arrow_linglu.png'  key="linglu-arrow">
        </div>
      </prod-item> -->
      <prod-item link="https://drawfee.ihapi.com" background="#FFFFFF" link-color="#000000">
        <img src='@/assets/img_logo_drawfee.png'  key="drawfee-logo" slot="prologo">
        <div slot="protitle">
          <img src='@/assets/img_slogan_drawfee.png' key="drawfee-text">
        </div>
        <div slot="protext" style="color:black">只要几秒，AI将你的简笔绘画生成为各种不同艺术家风格的作品，宫崎骏、新海诚、京阿尼、梵高、毕加索、莫奈等上百种风格任你选择，赶快来下载我是画手AI版吧！</div>
        <img slot="proimage" src='@/assets/img_main_drawfee.png' class="prod-img" key="drawfee-img">
        <div slot="linkdetail" style="border-radius: 20px; background-color: black">
          <span style="color: white">了解详情</span>
          <img src='@/assets/icon_arrow_drawfee.png'  key="drawfee-arrow">
        </div>
      </prod-item>
      <prod-item link="https://jielong.ihapi.com" background="#FFC333" link-color="#B36A00">
        <img src='@/assets/img_logo_draw.png'  key="dchainer-logo" slot="prologo">
        <div slot="protitle">
          <img src='@/assets/img_slogan_draw.png' key="dchainer-text">
        </div>
        <div slot="protext" style="color:#B36A00">趣味接龙小游戏，与“王牌”综艺梦幻联动。线上线下，天南地北，在这里开局零距离，一键连线“有趣灵魂”。赶快带着你的奇思妙想，妙语连珠加入我们吧！</div>
        <img slot="proimage" src='@/assets/img_main_draw.png' class="prod-img" key="dchainer-img">
        <div slot="linkdetail" style="border-radius: 20px; background-color: white">
          <span style="color: #B36A00">了解详情</span>
          <img src='@/assets/icon_arrow_draw.png'  key="dchainer-arrow">
        </div>
      </prod-item>
      <prod-item  link="https://quwan.ihapi.com" background="#101112" link-color="#979797">
        <img src='@/assets/img_logo_play.png' key="youxi-logo" slot="prologo">
<!--        <div slot="protitle">世界很大<br>你我有戏</div>-->
        <div slot="protitle">
          <img src='@/assets/img_slogan_play.png' key="dchainer-text">
        </div>
        <div slot="protext" style="color: #979797">百变社交体验，趣味桌游在线。破冰在即，你想玩的都在这里。熟人好友，这里有你想玩的，陌生有缘人，这里开展你们的缘分之旅～快来开启你的全新社交体验吧！</div>
        <img slot="proimage" src='@/assets/img_main_play.png' class="prod-img" key="youxi-img">
        <div slot="linkdetail" style="background-color: #353535; border-radius: 20px">
          <span style="color: #979797">了解详情</span>
          <img src='@/assets/icon_arrow_play.png'  key="play-arrow">
        </div>
      </prod-item>
      <!-- <prod-item link="http://qiaopi.ihapi.com" background="#583848" link-color="#FFFFFF">
        <img src='@/assets/img_logo_qiaopi.png'  key="qiaopi-logo" slot="prologo">
        <div slot="protitle">
          <img src='@/assets/img_slogan_qiaopi.png' key="qiaopi-text">
        </div>
        <div slot="protext" style="color:#FFFFFF">脑洞大开，悠闲聚会<br/>看谁的回答更有创意，并为他投上一票<br/>谁才是最终的俏皮大王呢？</div>
        <img slot="proimage" src='@/assets/img_main_qiaopi.png' class="prod-img" key="qiaopi-img">
        <div slot="linkdetail" style="border-radius: 20px; background-color: white">
          <span style="color: #000000">了解详情</span>
          <img src='@/assets/icon_arrow_qiaopi.png'  key="qiaopi-arrow">
        </div>
      </prod-item> -->
    </prodWarpper>
<!--    <cpn-footer></cpn-footer>-->
  </div>
</template>

<script>
import "@/lib/pcRem"
import cpnFooter from "@/components/pc/footer"
import prodWarpper from "@/views/pc/home/productWarpper"
import prodItem from "@/views/pc/home/productionItem"
export default {
  name: "Home",
  data() {
    return {
      // picPath: process.env.VUE_APP_PIC_PATH
      picPath: '@/assets'
    }
  },
  components: {
    prodItem,
    // cpnFooter,
    prodWarpper
  },
  mounted() {},
  methods: {}
}
</script>

<style lang="scss">
  @import "~@/assets/scss/globalFn.scss";
  .home-container{
    position: relative;
    width: 100%;
    height: 100%;
    min-width: cs(1024);
    overflow: hidden;
    .logo-icon{
      position: absolute;
      top: cs(24);
      left: cs(44);
      width: cs(70);
      height: cs(26);
      z-index: 10;
    }
  }
</style>
